<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div class="lightbox">
      <div>
        <h1>VIP名單登錄</h1>
        <p class="my-3">&nbsp;</p>
        <form
          name="_method"
          enctype="multipart/form-data"
          id="form"
          @submit.prevent="submitVipClient"
        >
          <!-- hidden -->
          <input type="hidden" name="RegNo" />
          <!-- hidden end -->
          <p class="formTitle">客戶單位<span class="red">*</span></p>
          <input
            type="text"
            name="VipCompany"
            class="textStyle maxText"
            maxlength="50"
            required
            v-model="VipCompany"
          />
          <p class="my-3">&nbsp;</p>
          <p class="formTitle">客戶姓名/稱謂 <span class="red">*</span></p>
          <input
            type="text"
            name="VipName"
            class="textStyle maxText"
            maxlength="50"
            required
            v-model="VipName"
          />
          <p class="my-3">&nbsp;</p>
          <p class="align_c">
            <input type="submit" value="確定送出" class="btnStyle" />
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      VipName: "",
      VipCompany: "",
      lang: "tw",
      MenuInvitation: [],
    };
  },

  methods: {
    closefancybox() {
      parent.$.fancybox.close();
    },

    submitVipClient() {
      const vm = this;
      const url = "/apiExhibitors/ClientVIP/";

      const info = {
        RegNo: vm.RegNo,
        VipCompany: vm.VipCompany,
        VipName: vm.VipName,
        CSRF: vm.CSRF_Token,
      };

      if (vm.lang == "tw") {
        if (!vm.VipName || !vm.VipCompany) {
          alert("輸入欄位不完整，請重新檢查！");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("您已成功完成 VIP 名單登錄！");
              vm.closefancybox();

              parent.window.location.reload();
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("此客戶已存在資料庫中！");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("申請已截止！");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      } else {
        if (!vm.VipName || !vm.VipCompany) {
          alert("There are incomplete fields, please check again.");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("Successfully sent VIP invitation");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert(
                "Sorry, the customer information is already in the database.",
              );
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 254) {
              alert("The application is closed.");
              vm.closefancybox();
              parent.window.location.reload();
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
              vm.closefancybox();
              parent.window.location.reload();
            }
          });
        }
      }
    },
  },

  created() {
    const vm = this;

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得語系

    let lang = "tw";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        // console.log(response.data)

        vm.MenuInvitation = response.data.Data;
      });

    $.getJSON(
      "/apiExhibitors/Exhibition/" + vm.RegNo,
      { lang: lang },
      function (data) {
        // console.log(data)
        $('[name="ExhTime"]').text(data.Data.ExhTime);
        //close day

        // console.log(data.Data.ExhBegin)

        //設定開展前七天
        var CloseDay = new Date(data.Data.ExhBegin);
        // console.log(CloseDay)
        CloseDay.setDate(CloseDay.getDate() - 7);
        $('[name="CloseDay"]').text(formatDate(CloseDay));
        function formatDate(date) {
          var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("/");
        }

        //當前時間 Timestamp
        var currentdate = Date.parse(new Date()).valueOf();
        // console.log(currentdate)

        //開展前七天日期 + 17:00 Timestamp
        var ExhTime = Date.parse(CloseDay) + 61200000;
        // console.log(ExhTime)

        if (currentdate > ExhTime) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnExpire");
          } else {
            $(".btnStyle").addClass("ebtnExpire");
          }
          $("form").remove();
        }
      },
    );

    //InvTotal
    $.getJSON(
      "/apiExhibitors/ClientVIPTotal_Quota/" + vm.RegNo,
      function (data) {
        // console.log(data.Data)
        $('[name="VipInvitationQuota"]').text(data.Data.VipInvitationQuota);
        $('[name="TotalVipRegistered"]').text(data.Data.TotalVipRegistered);

        //判斷VIP是否額滿
        if (data.Data.VipInvitationQuota == data.Data.TotalVipRegistered) {
          if (lang == "tw") {
            $(".btnStyle").addClass("btnFull");
          } else {
            $(".btnStyle").addClass("ebtnFull");
          }
        }
      },
    );
  },
};
</script>

<style lang="scss"></style>
